import React from 'react'
import './whats.css'
import { BiSolidPhoneCall } from 'react-icons/bi';
import { FaWhatsapp } from 'react-icons/fa';


function Whats() {
  return (
    <div className='whats'>
        <div className="whatsapp-float-container">
  <a href="tel:0568300288" className="whatsapp-float" rel="noopener noreferrer">
    <BiSolidPhoneCall size={40} />
  </a>
  <a href="https://wa.me/0568300288" className="whatsapp-float trans" target="_blank" rel="noopener noreferrer">
    <FaWhatsapp size={40} />
  </a>
</div>
    </div>
  )
}

export default Whats